'use client';

import React from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { LiquidGlassCard } from '@/components/liquid-glass/LiquidGlassCard';
import { MemoryPill } from './MemoryPill';

interface ArtifactReferenceCardProps {
  artifactId?: string;
  artifactTitle?: string;
  memories?: any[];
  onArtifactClick?: (artifactId: string) => void;
  /** Extra content rendered inside the card row (e.g., contextual banners). */
  children?: React.ReactNode;
}

/**
 * Saved-artifact reference card — shared by article and bubble render modes.
 * Clicking the card opens the artifact in the artifacts panel.
 */
export function ArtifactReferenceCard({
  artifactId,
  artifactTitle,
  memories,
  onArtifactClick,
  children,
}: ArtifactReferenceCardProps) {
  const memoryList = Array.isArray(memories) ? memories : [];
  return (
    <LiquidGlassCard
      variant="default"
      className="p-4 cursor-pointer hover:scale-[1.02] transition-transform"
      onClick={() => onArtifactClick?.(artifactId as string)}
    >
      <div className="flex items-center gap-3">
        <DocumentTextIcon className="h-5 w-5 text-foreground" />
        <div>
          <div className="font-medium text-foreground">
            {artifactTitle || 'Artifact'}
          </div>
          <div className="text-sm text-muted-foreground">
            Click to view in artifacts panel
          </div>
        </div>
        {children}
      </div>
      {memoryList.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3">
          {memoryList.map((memory: any, idx: number) => (
            <MemoryPill key={`${memory?.id || idx}`} memory={memory} index={idx} />
          ))}
        </div>
      )}
    </LiquidGlassCard>
  );
}

export default ArtifactReferenceCard;
